<template>
  <div id="basketball_playerDetail_matchRecord">
    <div class="select_row_box">
      <SelectItem
        v-for="selectItem in selectList"
        :key="selectItem.state"
        :options="selectItem"
        :curVal="selectItem.curVal"
        @changeValEvent="selectChangeVal"
      ></SelectItem>
    </div>
    <div class="group_container" ref="tableParentDom">
      <div
        class="table_container"
        v-if="tableColumnData && tableColumnData.length > 0"
      >
        <nodeTree_table
          :currThemeObj="currThemeObj"
          :currCid="currCid"
          :currSid="currSid"
          :tableMode="tableMode"
          :parentWidthPx="parentWidthPx"
          :isScrollFlag="isScrollFlag"
          :isClickFlag="isClickFlag"
          :variableColWidthVw="variableColWidthVw"
          :tableCellDefaultWidthVw="tableCellDefaultWidthVw"
          :defaultWidthVwNum="defaultWidthVwNum"
          :tableColumnData="tableColumnData"
          :tableData="tableData"
          :tableHeightPx="0"
          :jumpRouterPathNames="jumpRouterPathNames"
          @clickColumnEvent="clickColumn"
          :cellClassName="cellClassName"
          :arraySpanMethod="arraySpanMethod"
          :tableCustomCellRender="tableCustomCellRender"
          :initColumnIndex="initColumnIndex"
          valFormatReturnDefaultVal="- -"
          v-show="tableData && tableData.length > 0"
        ></nodeTree_table>
        <div class="common_elPage">
          <el-pagination
            v-show="tableData && tableData.length > 0"
            popper-class="mixtmt_pagination"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="pnum"
            :page-sizes="psizeArr"
            :page-size="psize"
            layout="total, prev, pager, next, sizes, jumper"
            :total="total"
          ></el-pagination>
        </div>
      </div>
      <cup_notData
        v-show="tableData && tableData.length === 0 && !this.loading"
        className="relativePtb30"
      ></cup_notData>
    </div>
  </div>
</template>
<script>
import {
  https_playerDetail_seasonList,
  https_playerDetail_matchstat,
} from '@api/platfrom_basketball_api'

import SelectItem from '@components/platfromBase/basketball/selectItem.vue'
import nodeTree_table from '@components/platfromBase/marathon/nodeTree_table.vue'
import cup_base_data_mixin from '@mixins/cup_base_data'
import cup_notData from '@components/base/NO_DATA.vue'

export default {
  name: 'basketball_playerDetail_matchRecord',
  components: { SelectItem, nodeTree_table, cup_notData },
  mixins: [cup_base_data_mixin],
  props: {
    matchInfor: {
      type: Object,
      default: () => ({
        teamId: '',
        teamName: '',
        teamLogo: '',
        teamWin: '',
        teamLosses: '',
        teamRank: '',
      }),
    },
  },
  data() {
    return {
      loading: false,
      tableMode: 'teamData',
      jumpRouterPathNames: null,
      parentWidthPx: 0,
      parentHeightPx: 0,
      isScrollFlag: true,
      isClickFlag: true,
      variableColWidthVw: 11.1,
      tableCellDefaultWidthVw: 5.55,
      defaultWidthVwNum: null,
      tableColumnData: [],
      initColumnIndex: 0,
      sortKey: '',
      pnum: 1,
      psize: 10,
      psizeArr: [10, 20, 30, 50],
      total: 0,
      tableData: null,
      tableCustomCellRender: {
        props: ['fieldGoals', 'freethrows', 'threePoints', 'twoPoints'],
        classNames: [
          'flexCloCenter',
          'flexCloCenter',
          'flexCloCenter',
          'flexCloCenter',
        ],
      },
      selectList: [
        {
          list: [],
          keyValArr: ['id', 'name'],
          placeholder: '请选择',
          isFilterable: false,
          widthVw: 9.74,
          curVal: '',
          state: 'season',
        },
        {
          list: [
            {
              id: '1',
              name: '常规赛',
            },
            {
              id: '2',
              name: '季后赛',
            },
            {
              id: '9',
              name: '保级赛',
            },
          ],
          keyValArr: ['id', 'name'],
          placeholder: '请选择',
          isFilterable: false,
          widthVw: 9.74,
          curVal: '',
          state: 'phaseType',
        },
      ],
      curSelect_season: '',
      curSelect_phaseType: '1',
    }
  },
  watch: {
    $route(to, from) {
      // 监听路由变化，矫正 tab 选中状态
      console.debug('$route:', from.query, to.query)
      if (JSON.stringify(from.query) !== JSON.stringify(to.query)) {
        // 头部切换球员时刷新数据
        this.query = to.query
        this.init()
      }
    },
  },
  created() {
    if (this.currThemeObj) {
      const moduleRouteNameEn = this.currThemeObj.moduleRouteNameEn
      this.jumpRouterPathNames = {
        pathName_teamDetail: `teamDetailIndex_${moduleRouteNameEn}`,
        pathName_playerDetail: `playerDetailIndex_${moduleRouteNameEn}`,
        pathName_matchDetail: `scheduleDetailIndex_${moduleRouteNameEn}`,
      }
    }
    this.query = this.$route.query
    this.init()
  },
  mounted() {
    this.parentWidthPx = this.$refs.tableParentDom.offsetWidth
    console.debug('this.parentWidthPx:', this.$refs.tableParentDom.scrollHeight)
  },
  computed: {},
  methods: {
    async init() {
      window.mixtmtBase_eventBus.$emit('loadingEvent', true)
      await this.getSeasonList(this.query)
      await this.getPlayerDetailMatchRecordList()
      window.mixtmtBase_eventBus.$emit('loadingEvent', false)
    },
    initSelectOpt() {
      let selectList = JSON.parse(JSON.stringify(this.selectList))
      this.selectList = selectList.map((item) => {
        if (item) {
          item.curVal = this[`curSelect_${item.state}`]
        }
        return item
      })
    },
    selectChangeVal(data) {
      console.debug('selectChangeVal:', data)
      let state = ''
      if (data.state === 'season') {
        this.curSelect_season = data.val
      } else if (data.state === 'phaseType') {
        this.curSelect_phaseType = data.val
        state = 'resetColumnData'
      }
      console.debug(this.curSelect_season)
      this.resetTable(state)
    },
    cellClassName({ row, column, rowIndex, columnIndex }) {
      let className = ''
      if (row.isPlay === 0 && columnIndex == 1) {
        className = 'unPlayRow'
      } else {
        this.tableCustomCellRender.props.forEach((cellItem) => {
          if (column.property === cellItem) {
            className = 'cell_clo2Row'
          }
        })
      }
      return className
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (row.isPlay === 0) {
        if (columnIndex === 1) {
          return [1, 16]
        } else if (columnIndex > 1) {
          return [0, 0]
        }
      }
    },
    clickColumn(prop) {
      // 多个表格点击排序事件
      console.debug('clickColumn:', prop)
      if (prop && typeof prop === 'string') {
        this.sortKey = prop
        this.resetTable()
      }
    },
    formatTableDataHandler(res) {
      if (
        res.data &&
        res.data.middle &&
        res.data.datas &&
        res.data.datas.length
      ) {
        this.total = res.data.total
        const leftColumns = res.data.left
        const middleColumns = res.data.middle
        const rightColumns = res.data.right
        // const fristColumns_left = leftColumns.slice(0, 3)
        // const otherColumns_left = leftColumns.slice(3)
        this.defaultWidthVwNum =
          res.data.middle.length +
          (res.data.left && res.data.left.length ? res.data.left.length - 1 : 0)
        if (this.tableColumnData.length == 0) {
          let tableColumnData = []
          let leftColumnObjArr = []
          let rightColumnObjArr = []
          if (leftColumns) {
            for (let i = 0; i < leftColumns.length; i++) {
              const item = leftColumns[i]
              if (i === 0) {
                leftColumnObjArr.push({
                  prop: 'matchDate-homeTeam-awayTeam',
                  label: item.colTitle,
                  widthVw: this.variableColWidthVw, //对应列的宽度，单位vw
                  className: i === 0 ? 'matchDate-homeTeam-awayTeam' : '', //单独定制的头部样式class
                  fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
                  selected: this.isClickFlag ? item.selected : false,
                })
              } else {
                leftColumnObjArr.push({
                  prop: item.colKey,
                  label: item.colTitle,
                  widthVw: this.tableCellDefaultWidthVw, //对应列的宽度，单位vw
                  className: i === 0 ? 'customCloTextAlignLeft' : '', //单独定制的头部样式class
                  fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
                  selected: this.isClickFlag ? item.selected : false,
                })
              }
            }
          }

          // const fristColumn = {
          //   prop: 'leftTeamName', //fristColumnPropArr.join('-'),
          //   label: '球队',
          //   widthVw: this.variableColWidthVw, //对应列的宽度，单位vw
          //   className: 'columnTeamNameClass', //单独定制的头部样式class
          //   fixed: 'left', //是否锁定，如果开启不滚动，此字段无效
          // }

          tableColumnData = [].concat(leftColumnObjArr)
          for (let i = 0; i < middleColumns.length; i++) {
            const item = middleColumns[i]
            tableColumnData.push({
              prop: item.colKey,
              label: item.colTitle,
              widthVw: this.tableCellDefaultWidthVw, //对应列的宽度，单位vw
              className: '', //单独定制的头部样式class
              selected: this.isClickFlag ? item.selected : false,
            })
          }

          if (rightColumns) {
            for (let i = 0; i < rightColumns.length; i++) {
              rightColumnObjArr.push({
                prop: item.colKey,
                label: item.colTitle,
                widthVw: this.variableColWidthVw, //对应列的宽度，单位vw
                className: 'columnTeamNameClass', //单独定制的头部样式class
                fixed: 'right', //是否锁定，如果开启不滚动，此字段无效
                selected: this.isClickFlag ? item.selected : false,
              })
            }
          }

          this.tableColumnData = [].concat(tableColumnData, rightColumnObjArr)
          this.tableColumnData.forEach((colItem, colIndex) => {
            if (colItem.selected) {
              this.initColumnIndex = colIndex
            }
          })
        }
        this.tableData = res.data
          ? res.data.datas.map((row) => {
              row.homeTeam = row.homeName
              row.awayTeam = row.awayName
              return row
            })
          : []
        console.debug('this.tableData:', this.tableData)
      } else {
        console.debug('暂无数据')
        this.tableData = []
      }
    },
    resetTable(state) {
      this.initTableParams(state)
      this.getPlayerDetailMatchRecordList()
    },
    initTableParams(state) {
      this.pnum = 1
      if (state === 'resetColumnData') {
        this.tableColumnData = []
      }
    },
    handleSizeChange(val) {
      this.psize = val
      this.resetTable()
      console.debug(`每页 ${val} 条`)
    },
    handleCurrentChange(val) {
      console.debug(`当前页: ${val}`)
      this.pnum = val
      this.getPlayerDetailMatchRecordList()
    },
    async getSeasonList(params) {
      await https_playerDetail_seasonList(
        this.axiosBaseUrl,
        this.$axios,
        params
      )
        .then((response) => {
          const res = response.data
          console.debug('res:', res)
          if (res.status === 0) {
            this.selectList[0].list = res.data.map((item) => {
              return {
                id: item.seasonId + '',
                name: item.seasonName,
              }
            })
            this.curSelect_season = res.data[0].seasonId + ''
            setTimeout(() => {
              this.initSelectOpt()
            }, 100)
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.matchPanel_matchInfor = null
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
    async getPlayerDetailMatchRecordList() {
      this.loading = true
      console.debug('sortKey:', this.sortKey)
      await https_playerDetail_matchstat(this.axiosBaseUrl, this.$axios, {
        cid: this.currCid,
        pid: this.query.pid,
        sid: this.curSelect_season,
        phid: this.curSelect_phaseType,
        asc: false,
        sort: this.sortKey,
        pnum: this.pnum,
        psize: this.psize,
      })
        .then((response) => {
          const res = response.data
          if (res.status === 0) {
            this.formatTableDataHandler(res)
            this.loading = false
          } else {
            if (res.message) {
              // message：null，因此不弹出警示框（一般404 || 500的时候）；
              // message不为null的时候展示警示框；
              this.$message({
                showClose: true,
                message: res.message ? res.message : '服务器异常，请稍后再试',
                type: 'warning',
              })
            }
          }
        })
        .catch((err) => {
          console.debug(err)
        })
    },
  },
}
</script>
<style lang="scss" scoped>
#basketball_playerDetail_matchRecord {
  padding-bottom: 2.778vw;
  .select_row_box {
    padding: 2.778vw 0 1.388vw 0;
    width: 100%;
    display: flex;
    display: -webkit-flex;
    justify-content: flex-start;
    align-items: center;
    & > div {
      margin-right: 0.694vw;
    }
  }
  .group_container {
    width: 100%;
    .group_box {
      padding: 1.388vw 0 2.778vw 0;
      .teamName {
        display: block;
        padding-bottom: 0.974vw;
        font-size: 1.25vw;
        font-weight: bold;
      }
    }

    .noDataClass {
      display: block;
      width: 100%;
      line-height: 5.55vw;
      text-align: center;
      font-size: 0.972vw;
      color: var(--mixtmt_greyColor2);
    }
    .noDataClass {
      border-top: 1px solid var(--mixtmt_greyColor0);
      border-bottom: 1px solid var(--mixtmt_greyColor0);
    }
  }
}
</style>
